import { useIsMobile } from '@/hooks/useMediaQuery';
import { useState } from 'react';

export function useDevice() {
    const [isTouch] = useState(!window.matchMedia('(hover: hover)').matches);
    const isMobile = useIsMobile();
    return { isTouch, isMobile };
}
